import {
  RESET_CAMPS,
  SET_DRAFT_CAMPAIGNS,
  SET_CAMPAIGN_TEMPLATE,
  SET_EXISTING_CAMPAIGNS,
  SET_DRAFT_CAMP_FOR_MEMB,
} from "../types";

const initialState = {
  CurrTemplate: {},
  draftCampaigns: {},
  draftCampForMemb: {},
  existingCampaigns: {},
};

const campaignsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CAMPAIGN_TEMPLATE:
      return {
        ...state,
        CurrTemplate: action.payload,
      };
    case SET_DRAFT_CAMPAIGNS:
      return {
        ...state,
        draftCampaigns: action.payload,
      };
    case SET_DRAFT_CAMP_FOR_MEMB:
      return {
        ...state,
        draftCampForMemb: action.payload,
      };
    case SET_EXISTING_CAMPAIGNS:
      return {
        ...state,
        existingCampaigns: action.payload,
      };
    case RESET_CAMPS:
      return initialState;
    default:
      return state;
  }
};

export default campaignsReducer;
